import { configureStore } from '@reduxjs/toolkit'
import savedColorsSlice from './modules/SavedColors/slice'
import colorPickerButtonSlice from './modules/colorPickerButton/slice'
import { companyApi } from './modules/company/api'
import { themeApi } from './modules/theme/api'
import { checkoutApi } from './modules/checkout/api'

export const store = configureStore({
  reducer: {
    [companyApi.reducerPath]: companyApi.reducer,
    [themeApi.reducerPath]: themeApi.reducer,
    [checkoutApi.reducerPath]: checkoutApi.reducer,
    savedColors: savedColorsSlice.reducer,
    colorPickerButton: colorPickerButtonSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      companyApi.middleware,
      themeApi.middleware,
      checkoutApi.middleware
    ),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
